import { isValidHttpUrl } from '../isValidHttpUrl';

// Unlike gallery thumbnails, LUT inputs must preserve the complete image and
// have enough pixels for the filtered display. Never fetch unresolved provider
// download references here; insertion resolves those through the host adapter.
export function getLutImageSource(resource, targetWidth) {
  if (resource.local) {
    return resource.src;
  }

  const sizes = Object.values(resource.sizes || {});
  const candidates = sizes.filter(
    (size) =>
      size.requestFullUrl !== true &&
      isValidHttpUrl(size.source_url) &&
      size.width > 0 &&
      size.height > 0 &&
      Math.abs(size.width / size.height - resource.width / resource.height) <
        0.01
  );
  const requiresDownload = sizes.some(
    (size) => size.requestFullUrl === true && size.source_url === resource.src
  );
  if (!requiresDownload && isValidHttpUrl(resource.src)) {
    candidates.push({
      width: resource.width,
      height: resource.height,
      source_url: resource.src,
    });
  }
  candidates.sort((a, b) => a.width - b.width);
  return (
    candidates.find((size) => size.width >= targetWidth) ||
    candidates[candidates.length - 1]
  )?.source_url;
}
